export default function fontChange() {
  const FONT_SIZES = ['small', 'medium', 'large'];
  const elementContainer = document.querySelector('.js-fontsize-selector');

  const setCurrent = (size) => {
    const htmlElement = document.documentElement;
    FONT_SIZES.forEach((fontSize) => {
      htmlElement.classList.toggle(`font-${fontSize}`, fontSize === size);
    });

    elementContainer?.querySelectorAll('[data-fontsize-selector]').forEach((element) => {
      if (element instanceof HTMLElement) {
        const elementSize = element.dataset.fontsizeSelector;
        element.classList.toggle('is-current', elementSize === size);
        element.setAttribute('aria-pressed', elementSize === size ? 'true' : 'false'); // アクセシビリティの向上
      }
    });
  };

  const getFontSizeFromStorage = () => {
    const storageSize = localStorage.getItem('fontsize');
    if (storageSize && FONT_SIZES.includes(storageSize)) {
      return storageSize;
    }

    const cookieSize = document.cookie.replace(
      /(?:(?:^|.*;\s*)fontsize\s*=\s*([^;]*).*$)|^.*$/,
      '$1',
    );
    return FONT_SIZES.includes(cookieSize) ? cookieSize : 'medium';
  };

  const setFontSize = (size) => {
    if (FONT_SIZES.includes(size)) {
      setCurrent(size);
      document.cookie = `fontsize=${size}; max-age=${60 * 60 * 24 * 365}; path=/; samesite=lax`;
      localStorage.setItem('fontsize', size); // 永続化
    }
  };

  const initFontSize = () => {
    const initialSize = getFontSizeFromStorage();
    setFontSize(initialSize);
  };

  if (!elementContainer) return;

  // 初期化処理
  initFontSize();

  // ボタンクリック時のフォントサイズ変更
  elementContainer.addEventListener('click', (event) => {
    const target = event.target;
    if (target instanceof HTMLElement) {
      const button = target.closest('[data-fontsize-selector]');
      if (button instanceof HTMLElement) {
        const size = button.dataset.fontsizeSelector;
        if (size) {
          setFontSize(size);
        }
      }
    }
  });

  // キーボード操作対応
  elementContainer.addEventListener('keydown', (event) => {
    const key = event.key;
    if (key === 'ArrowLeft' || key === 'ArrowRight') {
      const buttons = Array.from(elementContainer.querySelectorAll('[data-fontsize-selector]'));
      const currentIndex = buttons.findIndex((btn) => btn.classList.contains('is-current'));

      let newIndex;
      if (key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      } else if (key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % buttons.length;
      }

      buttons[newIndex].focus();
      const newSize = buttons[newIndex].dataset.fontsizeSelector;
      setFontSize(newSize);
    }
  });
}
